interface PageOptions {
  url: string
  appendId?: string

  // 是否隐藏iframe
  invisible?: boolean
}

/**
 * 创建iframe
 * @param pageOptions 页面选项
 * @returns iframe
 */
export function createIframe(pageOptions: PageOptions) {
  const iframe = document.createElement('iframe')
  iframe.src = pageOptions.url
  // @ts-ignore
  iframe.allowPaymentRequest = true
  iframe.allow =
    'identity-credentials-get;microphone *;camera *;midi;encrypted-media;clipboard-read *; clipboard-write *;geolocation *;payment *;'
  iframe.style.border = 'none'

  if (pageOptions.invisible) {
    iframe.style.visibility = 'hidden'
    iframe.style.display = 'none'
  } else if (pageOptions.appendId) {
    iframe.width = '100%'
    iframe.height = '100%'

    const container = document.querySelector(pageOptions.appendId)
    if (container) {
      container.appendChild(iframe)
    } else {
      throw new Error('appendId is required')
    }
  }

  return iframe
}
